// Base vide en production : l'API est servie sous /api sur le même domaine.
const API_BASE = process.env.REACT_APP_API_BASE || ''

export async function fetchPublic(path) {
  const response = await fetch(`${API_BASE}/api/public/${path}`)
  if (!response.ok) throw new Error(`Réponse ${response.status} de l'API`)
  return response.json()
}
